import api from '../api'
import {showWhitelistErrorModal} from './modals'


export function imageSearch(searchTerm,count,offset) {
  	return (dispatch) => api.fetchImageSearchResults(searchTerm,count,offset)
	    .then((response) => {
	    	return response
	    })
	    .catch((error) => {
	    	if(error.response && error.response.status ===403){

	    	}else{
				dispatch(showWhitelistErrorModal('imageSearch'))
			}
			throw error
		})
}


export function gifSearch(searchTerm,limit,offset) {
  	return (dispatch) => api.fetchGifSearchResults(searchTerm,limit,offset)
	    .then((response) => {
	    	return response
	    })
	    .catch((error) => {
			throw error
		})
}